<mat-nav-list>
  <a mat-list-item routerLink="/sites" routerLinkActive="active">
    <span mat-line>Sites</span>
    <mat-icon matListIcon>explore</mat-icon>
  </a>
</mat-nav-list>
